<template>
    <div class="main-container">
        <div class="filter-container" ref="filterContainer">
            <!-- <el-select-v2
                v-if="hasShop"
                class="filter-item"
                filterable
                v-model="filters.shop_user_id"
                clearable
                :options="shopUserList"
                :props="shopProps"
                placeholder="商户列表"
            /> -->
            <el-select-v2
                class="filter-item"
                filterable
                v-model="filters.brand_id"
                clearable
                :options="brandList"
                :props="brandProps"
                placeholder="全部品牌"
            />
            <el-select class="filter-item" filterable v-model="filters.appeal_status" placeholder="申诉状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option :label="AppealStatus[3]" :value="3"></el-option>
                <el-option :label="AppealStatus[0]" :value="0"></el-option>
                <el-option :label="AppealStatus[1]" :value="1"></el-option>
                <el-option :label="AppealStatus[2]" :value="2"></el-option>
            </el-select>
            <el-input class="filter-item" v-model="filters.search_value" placeholder="订单号/收货人/手机号" style="width:200px"
                clearable></el-input>
            <el-date-picker class="filter-item" v-model="filters.start_date" value-format="YYYY-MM-DD" placeholder="开始日期"
                style="width:170px"></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" value-format="YYYY-MM-DD" placeholder="结束日期"
                style="width:170px"></el-date-picker>
           
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="output()">批量导出</el-button>
            <el-button class="filter-btn" clearable type="primary" @click="dialogVisible1 = true"
            v-if="permission.includes(store.state.user.userInfo.username)">减免人工罚款</el-button>
            <el-divider></el-divider>
            <div class="summary-box">
                <div class="summary-item">
                    <p class="label">罚款金额</p>
                    <p class="txt">{{ totalAmount.fk_amount }}</p>
                </div>
                <div class="summary-item">
                    <p class="label">最终罚款金额</p>
                    <p class="txt">{{ totalAmount.zz_jm_amount }}</p>
                </div>
                <div class="summary-item">
                    <p class="label">罚款减免金额</p>
                    <p class="txt">{{ totalAmount.jm_amount }}</p>
                </div>
            </div>
            <el-divider></el-divider>
        </div>
        <el-table :data="tableData" border :height="tableHeight">
            <el-table-column prop="order_id" label="订单id" width="150">
                <template #default="scope">
                    订单id：{{ scope.row.order_id }}<br />
                    订单号：{{ scope.row.order_no }}<br />
                </template>
            </el-table-column>
            <el-table-column label="商品">
                <template #default="scope">
                    <img :src="scope.row.image_path" width="50" height="40" class="image_path" />
                </template>
            </el-table-column>
            <el-table-column label="商品信息" width="170">
                <template #default="scope">
                    品牌：{{ scope.row.brand_name }}<br />商品：{{ scope.row.product_name }}<br />规格：{{ scope.row.spec_name }}<br />
                </template>
            </el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
            <el-table-column prop="ship_amount" label="运费"></el-table-column>
            <el-table-column prop="total_amount" label="订单金额"></el-table-column>
            <el-table-column label="发货信息" width="170">
                <template #default="scope">
                    收货人：{{ scope.row.name }}<br />手机号：{{ scope.row.phone }}<br />
                    <span
                        v-if="scope.row.ship_time != '' && scope.row.ship_time != null">发货时间:{{ scope.row.ship_time }}</span><br />
                    <span
                        v-if="scope.row.refund_time != '' && scope.row.refund_time != null">退款时间:{{ scope.row.refund_time }}</span>
                </template>
            </el-table-column>
            <el-table-column label="延迟发货">
                <template #default="scope">
                    <template v-if="scope.row.delay_delivery">
                        <span>类型:{{ DelayTypes[scope.row.delay_delivery] }}</span><br />
                        <span>时间:{{ scope.row.delay_delivery_time }}</span><br />
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="人工罚款" width="200">
                <template #default="scope">
                    <template v-if="scope.row.manual_fine.fine_date">
                        <span>罚款时间:{{ scope.row.manual_fine.fine_date }}</span><br />
                        <span>罚款原因:{{ scope.row.manual_fine.fine_reason }}</span><br />
                        <span>罚款金额:{{ scope.row.manual_fine.fine_money }}</span><br />
                        <div class="detail">
                            <span>减免金额:{{ scope.row.manual_fine.fine_reduce }}</span>
                            <span class="color" @click="dialogVisible2 = true, toDetail(scope.row.id,2)">详情</span>
                        </div>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="系统罚款" width="200">
                <template #default="scope">
                    <template v-if="scope.row.system_fine.fine_date">
                        <span>罚款时间:{{ scope.row.system_fine.fine_date }}</span><br />
                        <span>罚款原因:{{ scope.row.system_fine.fine_reason }}</span><br />
                        <span>罚款金额:{{ scope.row.system_fine.fine_money }}</span><br />
                        <div class="detail">
                            <span>减免金额:{{ scope.row.system_fine.fine_reduce }}</span>
                            <span class="color" @click="dialogVisible2 = true, toDetail(scope.row.id,1)">详情</span> 
                        </div>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="express_status_val" label="商品状态"></el-table-column>
            <el-table-column prop="appeal_status_val" label="申诉状态"></el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <div class="action-list">
                        <el-button :disabled="scope.row.is_appeal == 0 || scope.row.is_work_fine == 1" type="primary" size="small"
                            @click="openDialog(scope.row)">申诉</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="count" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- 申诉弹框 -->
        <el-dialog title="申诉" v-model="dialogVisible" :before-close="dialogBeforeClose">
            <div class="msg" style="margin-bottom:10px;color:red;text-indent:50px;transform:translateY(-15px)">注：该申诉仅针对非工单类罚款</div>
            <el-form :model="currRow" label-width="120px">
                <el-form-item label="申诉类型" required>
                    <el-select v-model="type" placeholder="选择申诉类型" clearable>
                        <el-option :value="TypeStatus['全部']" label="全部" v-if="currRow.system_fine.fine_date && currRow.manual_fine.fine_date && currRow.is_system_fine && currRow.is_manual_fine"></el-option>
                        <el-option :value="TypeStatus['系统罚款']" label="系统罚款" v-if="currRow.system_fine.fine_date && currRow.is_system_fine"></el-option>
                        <el-option :value="TypeStatus['人工罚款']" label="人工罚款" v-if="currRow.manual_fine.fine_date && currRow.is_manual_fine"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申诉原因" required style="width:450px">
                    <el-input type="textarea" :rows="5" maxlength="150" show-word-limit v-model="appeal_reason"></el-input>
                </el-form-item>
                <el-form-item label="申诉证明">
                    <ul class="preview-list el-upload-list el-upload-list--picture-card">
                        <li class="preview-item el-upload-list__item" v-for="(item, index) in appeal_file" :key="item">
                            <el-image :src="item" :preview-src-list="appeal_file" :initial-index="index" fit="scale-down"
                                hide-on-click-modal append-to-body :z-index="3000"></el-image>
                                <el-icon v-if="currAppeal != 2" class="icon el-icon-delete" @click="onRemove(index)" >
                                <Delete />
                                </el-icon>
                            <!-- <i v-if="currAppeal != 2" class="icon el-icon-delete" @click="onRemove(index)"></i> -->
                        </li>
                        <el-upload v-if="currAppeal != 2" class="el-upload-list__item empty-item"
                            accept="image/png,image/jpg,image/jpeg" action="uploadUrl" :before-upload="onBeforeUpload"
                            :http-request="onImgUpload" :file-list="appeal_file" :show-file-list="false"
                            list-type="picture-card" multiple>
                            <el-icon>
                                <Plus />
                            </el-icon>
                        </el-upload>
                    </ul>
                    <div v-if="currAppeal != 2" style="color:red">*注：图片不能大于500k</div>
                </el-form-item>
                <el-form-item>
                    <div v-if="reject_reason" style="color:red">*驳回原因：{{ reject_reason }}</div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogBeforeClose">取 消</el-button>
                <el-button :disabled="currAppeal == 2" type="primary" @click="onApply">确 定</el-button>
            </template>
        </el-dialog>
        <!-- 上传弹框 -->
        <el-dialog title="人工罚款批量上传" v-model="dialogVisible1" :before-close="dialogBeforeClose1">
            <el-form label-width="80px">
                <el-form-item>
                    <el-upload class="upload-demo" ref="upload" :action="`/api/admin/fine_order/batch_manual_fine?user_id=${store.state.user.userInfo.id}`"
                        :on-success="onUploadSuccess" accept=".xls,.xlsx" :auto-upload="false">
                        <el-button type="primary" size="small">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link :href="`${Keys.baseUrl}/admin/fine_order/getManualFineMb`"
                        type="primary">下载批量减免人工罚款模版</el-link>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogBeforeClose1">取 消</el-button>
                <el-button type="primary" @click="dialogSubmit">确 定</el-button>
            </template>
        </el-dialog>
        <!-- 罚款申诉详情弹窗 -->
        <el-dialog title="罚款明细" v-model="dialogVisible2" :before-close="dialogBeforeClose2">
            <el-table :data="tableDialogData" border>
                <el-table-column prop="reason" label="罚款原因"></el-table-column>
                <el-table-column prop="money" label="罚款金额"></el-table-column>
                <el-table-column prop="reduce" label="最终减免金额"></el-table-column>
                <el-table-column prop="created_at" label="罚款时间"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick } from 'vue'
import { onBeforeRouteLeave,userRoute } from 'vue-router'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { beforeUpload, upload } from '@/utils/upload'
import { joinParams } from '@/utils'
import { DelayTypes, AppealStatus,TypeStatus } from '@/enums/order'
import { UserType } from '@/enums/user'
import { getLastMonthToday, getCurrentDate } from '@/utils/index'
import Pagination from '@/components/Pagination'
import { Plus,Delete } from '@element-plus/icons-vue'

export default defineComponent({
    name: 'MerchantList',
    components: { Pagination, Plus,Delete },
    setup() {
        const { proxy } = getCurrentInstance()
        const store = useStore()
        const route = useRoute()

        const hasShop = store.state.user.userInfo.hasShop
        const today = new Date()
        const permission = ["caiwu", "admin"]
        const state = reactive({
            filters: {
                order_type: '3',
                search_value: '',
                time_type: '3',
                appeal_status: route.query.AppealStatus==0 ?'':Number(route.query.AppealStatus) || 3,
                start_date: route.query.start_date || getLastMonthToday(),
                end_date: route.query.end_date || getCurrentDate(),
                item_name: '',
                brand_id: null,
                shop_user_id: null,
                limit: 10,
                page: 1,
            },
            totalAmount: {
                fk_amount:0,
                zz_jm_amount:0,
                jm_amount:0,
            },
            brandList: [], // 当前用户关联品牌（非商户类获取全部）
            brandProps: {
                value: 'id',
                label: 'name'
            },
            tableData: [],
            tableDialogData: [], //罚款申诉详情弹窗
            tableHeight: 0, // table 动态高度
            shopUserList: [],
            shopProps: {
                value: 'id',
                label: 'shop_description'
            },
            count: 0,
            currRow: {},  // 当前操作数据行

            dialogVisible: false,   // 申诉弹框
            dialogVisible2: false,  //详情弹框
            dialogVisible1: false,   // 上传弹框
            appeal_reason: '',     // 申诉原因
            type: '',           //申诉类型
            appeal_file: [],     // 申诉证明
            reject_reason: '',     // 驳回原因
            currOrderItemId: '',     // 当前操作订单ID
            currAppeal: '',     // 当前操作申诉类型：1-可进行申诉；2-已申诉，可获取申诉信息
            onSizeChange(val) {
                state.filters.limit = val
                state.getList()
            },
            onPageChange(val) {
                state.filters.page = val
                state.getList()
            },
            getList() {
                proxy.$http.get(`/admin/fine_order/getFineOrderList?${joinParams({ ...state.filters })}`).then(res => {
                    if (res.code == 0) {
                        state.tableData = res.data
                        state.count = res.count
                    } else {
                        state.tableData = [];
                    }
                })
                //调取金额接口
                proxy.$http.get(`/admin/Merchant/get_order_fineinfo?${joinParams({ ...state.filters })}`).then(res => {
                    const {data,code,msg} = res
                    if (code == 200) {
                        state.totalAmount = data
                    } else {
                        proxy.$message({ type: 'error', message: msg })
                    }
                })
            },
            //罚款申诉详情
            toDetail(id,type) {
                proxy.$http.post('/admin/fine_order/getFineRecordList',{order_item_id:id,type}).then((res) => {
                    if(res.code == 200) {
                        state.tableDialogData = res.data
                    } else {
                        state.tableDialogData = [];
                    }
                })
            },
            // 获取当前用户关联品牌列表
            getBrandList: () => {
                proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then((res) => {
                    state.brandList = res.data
                })
            },
            getShopList: () => {
                proxy.$http.get('/admin/shop_product/getShopList').then(res => {
                    if (res.code == 200) {
                        state.shopUserList = res.data
                    } else {
                        state.shopUserList = []
                    }
                })
            },
            search() {
                state.filters.page = 1;
                state.getList();
            },
            output() {
                window.open(`${Keys.baseUrl}/admin/fine_order/exportFineOrderData?${joinParams({ ...state.filters, user_id: store.state.user.userInfo.id })}`)
            },
            // 批量上传成功
            onUploadSuccess: async (res) => {
                const { code, data, msg } = res
                if (code != 200) {
                    return proxy.$message({ type: 'error', message: msg })
                }
                state.dialogBeforeClose1()
            },
            // 关闭弹框前清空已上传文件列表
            dialogBeforeClose1: () => {
                proxy.$refs.upload.clearFiles()
                state.dialogVisible1 = false
                state.getList()
            },
            // 关闭罚款弹框
            dialogBeforeClose2: () => {
                state.dialogVisible2 = false
            },
            //确定上传
            dialogSubmit: () => {
                proxy.$refs.upload.submit()
            }
        })
        // 打开申诉弹框
        const openDialog = (row) => {
            const { id, is_appeal } = row
            state.currRow = row
            if (is_appeal == 1) {
                state.currOrderItemId = id
            } else {
                getAppealInfo(id)
            }
            state.currAppeal = is_appeal
            state.dialogVisible = true
        }
        // 商品详情图上传前校验
        const onBeforeUpload = (file) => {
            return beforeUpload(file, { size: 500 })
        }
        // 商品图片上传事件
        const onImgUpload = (param) => {
            uploadRequest(param)
        }
        // 自定义图片上传方法
        const uploadRequest = async (param) => {
            const res = await upload(param.file, { folderName: 'others' })
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { o_path } = data.img_info
            state.appeal_file.push(o_path)
        }
        // 图片删除
        const onRemove = (index) => {
            state.appeal_file.splice(index, 1)
        }
        // 申诉
        const onApply = () => {
            const { appeal_reason, appeal_file, currOrderItemId,type } = state
            if (!appeal_reason) {
                return proxy.$message({ type: 'error', message: '请输入申诉原因' })
            }
            if (type === '') {
                return proxy.$message({ type: 'error', message: '请输入申诉类型' })
            }
            proxy.$confirm('每笔订单只有一次申诉机会，确定要提交进入审批流程吗?', '提示', {
                type: 'warning'
            }).then(() => {
                proxy.$http.post('/admin/fine_order/sendFineAppeal', { type,order_item_id: currOrderItemId, appeal_reason, appeal_file: appeal_file.join(',') }).then(res => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    dialogBeforeClose()
                    state.getList()
                })
            }).catch(() => {
                console.log('取消申诉')
            })
        }
        // 获取申诉信息
        const getAppealInfo = (id) => {
            proxy.$http.get(`/admin/fine_order/getFineAppealInfo?order_item_id=${id}`).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                const { appeal_reason, appeal_file, reject_reason, type } = data
                state.type = type
                state.appeal_reason = appeal_reason
                state.appeal_file = appeal_file && appeal_file.split(',') || []
                state.reject_reason = reject_reason
            })
        }
        // 申诉弹框关闭前清空数据
        const dialogBeforeClose = () => {
            state.dialogVisible = false
            state.type = ''
            state.appeal_reason = ''
            state.appeal_file = []
            state.reject_reason = ''
        }
        // 设置 table 高度
        const setTableHeight = () => {
            nextTick(() => {
                let headerHeight = 50,  // 头部高度
                    filterHeight = proxy.$refs.filterContainer.offsetHeight + 30, // 搜索条件框高度 + 间距
                    paginationHeight = 62 // 分页栏高度 + 与 table 之间的间距
                state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight
            })
        }
        // 设置 table 高度
        setTableHeight()
        // 监听窗口变化，重置 table 高度
        window.onresize = setTableHeight
        // 注销 onresize 监听
        onBeforeRouteLeave(() => { window.onresize = null })
        state.getList()
        hasShop && state.getShopList()
        state.getBrandList()
        return { ...toRefs(state), Keys, store, hasShop, permission, onApply, dialogBeforeClose, onBeforeUpload, onImgUpload, openDialog, onRemove, DelayTypes, AppealStatus, TypeStatus, UserType }
    }
})
</script>

<style lang="stylus" scoped>
    .preview-item
        position relative
        &:hover .icon
            display block
        .icon
            display none
            position absolute
            right 0
            bottom 0
            width 100%
            height 30px
            line-height 30px
            background rgba(0, 0 , 0, .5)
            text-align center
            color #fff
            cursor pointer
    .empty-item
        border none
    .el-table .cell .detail
        display: flex;
        justify-content: space-between;
    .el-table .cell .detail .color
        color: #625adf;
    .summary-box
        display flex
        justify-content space-around
        .summary-item
            text-align center
            .label
                font-size 18px
            .txt
                font-size 16px
                font-weight bold
                margin-top 20px
                color #666666
</style>